import { Box } from '@glplus/glpweb-dsl';
import { useTranslation } from 'react-i18next';

/** Public reader: hosted text and Runner chrome update through web deploys.
 * Deliberately outside RequireAuth so signed-out and store-review users can read it. */
export default function RunnerLegalDocument({ document }: { document: 'terms' | 'privacy' }) {
  const { i18n } = useTranslation();
  const site = ((import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined) ?? 'https://www.grocerylistplus.com').replace(/\/+$/, '');
  const es = i18n.language.startsWith('es');
  const title = document === 'terms' ? (es ? 'Términos de Runner' : 'Runner Terms') : (es ? 'Privacidad de Runner' : 'Runner Privacy');
  return <Box component="iframe" title={title} src={`${site}/drivers/${document}`} data-testid="runner-legal-document"
    sx={{ display: 'block', border: 0, width: '100%', height: '100dvh', backgroundColor: '#F5F7FA' }} />;
}
